import { ReactNode } from "react";

const VARIANTS = {
  DEFAULT:
    "w-40 h-8 rounded-xl border-2 border-white text-black bg-cream-700 hover:bg-white"
};

interface Props {
  onClick?: () => void;
  className?: string;
  variant?: keyof typeof VARIANTS;
  children: ReactNode;
}

export const BaseButton = ({
  variant = "DEFAULT",
  children,
  className,
  onClick
}: Props) => {
  return (
    <button onClick={onClick} className={`${className} ${VARIANTS[variant]}`}>
      {children}
    </button>
  );
};
